import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initData } from './reducers/data';
import App from './components/App/App';
import './index.css';

// the id of the div to render too
let appId = 'asdash';

// default app params
initParams.apiUrl = `${process.env.REACT_APP_API_URL}`;

if(window.portfolioMapper) {
  if(window.portfolioMapper.clientEmail) {
    initParams.clientEmail = window.portfolioMapper.clientEmail;
  }
  if(window.portfolioMapper.token) {
    initParams.token = window.portfolioMapper.token;
  }
}

// render
ReactDOM.render(
  <Provider
    store={createStore(
      reducers,
      { params: initParams, data: initData },
      applyMiddleware(thunk),
    )}
  >
    <App />
  </Provider>,
  document.getElementById(appId),
);
